export const errorBoundary = {
  title: {
    en: 'Something went wrong',
    nb: 'Beklager, noe gikk galt',
    nn: 'Beklager, noe gikk galt',
  },
  message: {
    en: 'A technical error has occurred, and the page is temporarily unavailable.',
    nb: 'En teknisk feil har oppstått, og siden er midlertidig utilgjengelig.',
    nn: 'Ein teknisk feil har oppstått, og sida er mellombels utilgjengeleg.',
  },
  suggestionsTitle: {
    en: 'You can try to:',
    nb: 'Du kan prøve å:',
    nn: 'Du kan prøve å:',
  },
  suggestionReloadPrefix: {
    en: 'wait a few minutes and',
    nb: 'vente i noen minutter og',
    nn: 'vente i nokre minutt og',
  },
  suggestionReloadLink: {
    en: 'reload the page',
    nb: 'laste siden på nytt',
    nn: 'laste sida på nytt',
  },
  suggestionGoBackLink: {
    en: 'go back to the previous page',
    nb: 'gå tilbake til forrige side',
    nn: 'gå tilbake til førre side',
  },
  contactInfoPrefix: {
    en: 'If you still experience problems, you can contact us at',
    nb: 'Hvis du fortsatt har problemer kan du kontakte oss på',
    nn: 'Hvis du framleis har problem kan du kontakte oss på',
  },
  includeCorrelationIdInfo: {
    en: 'Please include the Error ID in the email.',
    nb: 'Husk å oppgi feil-ID i e-posten.',
    nn: 'Husk å oppgi feil-ID i e-posten.',
  },
  correlationIdLabel: {
    en: 'Error ID:',
    nb: 'Feil-ID:',
    nn: 'Feil-ID:',
  },
  returnHomeButton: {
    en: 'Go to home page',
    nb: 'Gå til forsiden',
    nn: 'Gå til framsida',
  },
  tryAgainButton: {
    en: 'Reload page',
    nb: 'Last siden på nytt',
    nn: 'Last sida på nytt',
  },
} as const;
